// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__34INJ","sendOtp":"AuthorizeToLogin_sendOtp__3USi-"};